import { autoinject } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";

@autoinject()
export class SearchHistoryClientService {

    constructor(private requestClient: RequestClientService) { }

    public deleteSearchResults(searchHistoryEntryIds: number[]) : Promise<any> {
        return this.requestClient.delete('SearchHistoryApi/deleteSearchResults', null, searchHistoryEntryIds);
    }
}